module.exports = __webpack_public_path__ + "static/media/y-combinator.86eafb5a.svg";